export interface ShippingMethodConstructor {
  id: number
  name: string
  description: string
  active: boolean
}

export class ShippingMethod {
  readonly id: number
  readonly name: string
  readonly description: string
  readonly active: boolean

  constructor(data: ShippingMethodConstructor) {
    this.id = data.id
    this.name = data.name
    this.description = data.description
    this.active = data.active
  }
}
